(function () {
  function formatMoney(cents, format) {
    if (typeof Shopify !== 'undefined' && typeof Shopify.formatMoney === 'function') {
      return Shopify.formatMoney(cents, format);
    }
    return '$' + (cents / 100).toFixed(2);
  }

  class SubscriptionBuyBox {
    constructor(root) {
      this.root = root;
      this.form = root.querySelector('.sbb-product-form');
      this.dynamicInputs = root.querySelector('.sbb-dynamic-inputs');
      this.mainVariantInput = root.querySelector('.sbb-main-variant-id');
      this.submitBtn = root.querySelector('.sbb-submit-btn');
      this.options = root.querySelectorAll('.sbb-option');
      this.variantSelects = root.querySelectorAll('.sbb-variant-select');
      this.qtyInput = root.querySelector('[data-sbb-qty-input]');
      this.qtyMinusBtn = root.querySelector('[data-sbb-qty-minus]');
      this.qtyPlusBtn = root.querySelector('[data-sbb-qty-plus]');

      this.defaultVariantId = root.dataset.defaultVariantId;
      this.starterPlanId = root.dataset.starterPlanId;
      this.partnerPlanId = root.dataset.partnerPlanId;
      this.gift1Id = root.dataset.gift1Id;
      this.gift2Id = root.dataset.gift2Id;
      this.gift1Available = root.dataset.gift1Available !== 'false';
      this.gift2Available = root.dataset.gift2Available !== 'false';
      this.moneyFormat = root.dataset.moneyFormat || '${{amount}}';
      this.defaultButtonText =
        this.submitBtn?.dataset.defaultText ||
        this.submitBtn?.querySelector('.button-text')?.textContent?.trim() ||
        'START NOW';
      this.soldOutText =
        this.submitBtn?.dataset.soldOutText ||
        (typeof window !== 'undefined' && window.variantStrings?.soldOut) ||
        'Sold out';

      const variantsJson = root.querySelector('[data-sbb-variants]');
      this.variants = variantsJson ? JSON.parse(variantsJson.textContent) : [];

      const colorsJson = root.querySelector('[data-sbb-variant-colors]');
      this.variantColors = colorsJson ? JSON.parse(colorsJson.textContent) : {};
      const giftImagesJson = root.querySelector('[data-sbb-variant-gift-images]');
      this.variantGiftImages = giftImagesJson ? JSON.parse(giftImagesJson.textContent) : {};
      const mediaJson = root.querySelector('[data-sbb-variant-media]');
      this.variantMediaIds = mediaJson ? JSON.parse(mediaJson.textContent) : {};
      const galleryAltsJson = root.querySelector('[data-sbb-gallery-media-alts]');
      this.galleryMediaAlts = galleryAltsJson ? JSON.parse(galleryAltsJson.textContent) : {};
      const optionMediaMapJson = root.querySelector('[data-sbb-option-media-map]');
      this.optionMediaMap = optionMediaMapJson ? JSON.parse(optionMediaMapJson.textContent) : {};
      this.defaultAccentStart = root.dataset.defaultAccentStart || '#586e46';
      this.defaultAccentEnd = root.dataset.defaultAccentEnd || '#8fb86f';
      this.sectionId = root.dataset.sectionId;

      this.selectedOption = root.dataset.defaultOption || 'starter';
      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.init();
    }

    resetAccordionPanel(body) {
      if (!body) return;
      body.classList.remove('is-open');
      body.style.height = '0px';
      body.style.display = 'none';
    }

    openAccordionPanel(body, animate = true) {
      if (!body) return;

      const isFullyOpen =
        body.classList.contains('is-open') &&
        body.style.display !== 'none' &&
        (body.style.height === 'auto' || parseFloat(body.style.height) > 0);

      if (isFullyOpen) return;

      body.style.display = 'block';
      body.style.visibility = 'visible';
      body.classList.add('is-open');

      if (!animate || this.reducedMotion) {
        body.style.height = 'auto';
        return;
      }

      body.style.height = '0px';
      const targetHeight = body.scrollHeight;

      requestAnimationFrame(() => {
        body.style.height = `${targetHeight}px`;
      });

      const onTransitionEnd = (event) => {
        if (event.target !== body || event.propertyName !== 'height') return;
        body.removeEventListener('transitionend', onTransitionEnd);
        if (body.classList.contains('is-open')) {
          body.style.height = 'auto';
        }
      };

      body.addEventListener('transitionend', onTransitionEnd);
    }

    closeAccordionPanel(body, animate = true) {
      if (!body || !body.classList.contains('is-open')) return;

      if (!animate || this.reducedMotion) {
        this.resetAccordionPanel(body);
        return;
      }

      if (body.style.height === 'auto' || !body.style.height) {
        body.style.height = `${body.scrollHeight}px`;
      }

      body.offsetHeight;
      body.classList.remove('is-open');

      requestAnimationFrame(() => {
        body.style.height = '0px';
      });

      const onTransitionEnd = (event) => {
        if (event.target !== body || event.propertyName !== 'height') return;
        body.removeEventListener('transitionend', onTransitionEnd);
        if (!body.classList.contains('is-open')) {
          this.resetAccordionPanel(body);
        }
      };

      body.addEventListener('transitionend', onTransitionEnd);
    }

    syncAccordion(optionKey, animate = true) {
      const panelsToClose = [];
      let panelToOpen = null;

      this.options.forEach((option) => {
        const body = option.querySelector('.sbb-option-body');
        if (!body) return;

        const shouldOpen = option.dataset.option === optionKey;

        if (shouldOpen) {
          panelToOpen = body;
        } else if (body.classList.contains('is-open') || body.style.display !== 'none') {
          panelsToClose.push(body);
        } else {
          this.resetAccordionPanel(body);
        }
      });

      panelsToClose.forEach((body) => this.closeAccordionPanel(body, animate));

      if (panelToOpen) {
        if (animate) {
          this.openAccordionPanel(panelToOpen, true);
        } else {
          panelToOpen.style.display = 'block';
          panelToOpen.style.visibility = 'visible';
          panelToOpen.style.height = 'auto';
          panelToOpen.classList.add('is-open');
        }
      }
    }

    getOnetimeQuantity() {
      if (!this.qtyInput) return 1;
      const min = parseInt(this.qtyInput.min, 10) || 1;
      const max = parseInt(this.qtyInput.max, 10) || 99;
      const value = parseInt(this.qtyInput.value, 10);
      if (!Number.isFinite(value)) return min;
      return Math.min(max, Math.max(min, value));
    }

    syncOnetimeQuantityInput() {
      if (!this.qtyInput) return;
      const quantity = this.getOnetimeQuantity();
      this.qtyInput.value = quantity;
      this.updateQtyButtons();
    }

    updateQtyButtons() {
      if (!this.qtyInput) return;
      const quantity = this.getOnetimeQuantity();
      const min = parseInt(this.qtyInput.min, 10) || 1;
      const max = parseInt(this.qtyInput.max, 10) || 99;

      if (this.qtyMinusBtn) {
        this.qtyMinusBtn.disabled = quantity <= min;
      }
      if (this.qtyPlusBtn) {
        this.qtyPlusBtn.disabled = quantity >= max;
      }
    }

    bindQuantityControls() {
      if (!this.qtyInput) return;

      const stopPropagation = (event) => {
        event.stopPropagation();
      };

      this.qtyInput.addEventListener('click', stopPropagation);
      this.qtyInput.addEventListener('keydown', stopPropagation);

      this.qtyInput.addEventListener('change', () => {
        this.syncOnetimeQuantityInput();
        this.updateFormInputs();
      });

      this.qtyInput.addEventListener('blur', () => {
        this.syncOnetimeQuantityInput();
        this.updateFormInputs();
      });

      if (this.qtyMinusBtn) {
        this.qtyMinusBtn.addEventListener('click', (event) => {
          event.preventDefault();
          event.stopPropagation();
          this.qtyInput.stepDown();
          this.syncOnetimeQuantityInput();
          this.updateFormInputs();
        });
      }

      if (this.qtyPlusBtn) {
        this.qtyPlusBtn.addEventListener('click', (event) => {
          event.preventDefault();
          event.stopPropagation();
          this.qtyInput.stepUp();
          this.syncOnetimeQuantityInput();
          this.updateFormInputs();
        });
      }

      this.syncOnetimeQuantityInput();
    }

    getAccentVariantId() {
      if (this.selectedOption === 'partner' && this.variantSelects.length > 0) {
        return this.variantSelects[0].value || this.defaultVariantId;
      }
      return this.defaultVariantId;
    }

    syncPartnerSelectsFromMain(variantId) {
      const id = String(variantId || this.defaultVariantId || '');
      if (!id || this.variantSelects.length === 0) return;

      const primarySelect = this.variantSelects[0];
      const hasOption = Array.from(primarySelect.options).some((option) => option.value === id);
      if (!hasOption) return;

      primarySelect.value = id;
      this.updateVariantThumb(primarySelect);
    }

    applyAccentColors(variantId) {
      const entry = this.variantColors[String(variantId)] || {};
      const start = entry.start || this.defaultAccentStart;
      const end = entry.end || this.defaultAccentEnd;

      this.root.style.setProperty('--sbb-accent-start', start);
      this.root.style.setProperty('--sbb-accent-end', end);
      this.root.style.setProperty('--sbb-selected-border', start);
      this.root.style.setProperty('--sbb-selected-bg', `color-mix(in srgb, ${start} 12%, white)`);
      this.root.style.setProperty('--sbb-badge-bg', start);
      this.root.style.setProperty(
        '--sbb-gifts-panel-bg',
        `linear-gradient(95deg, ${start} 11%, ${end} 100%)`
      );
      this.root.style.setProperty('--sbb-btn-start', start);
      this.root.style.setProperty('--sbb-btn-end', end);
    }

    updateGiftImages(variantId) {
      const entry = this.variantGiftImages[String(variantId)] || {};
      const gift1Url = this.resolveGiftUrl(entry.gift1);
      const gift2Url = this.resolveGiftUrl(entry.gift2);

      this.root.querySelectorAll('[data-sbb-gift-img="1"]').forEach((img) => {
        if (gift1Url) img.src = gift1Url;
      });
      this.root.querySelectorAll('[data-sbb-gift-img="2"]').forEach((img) => {
        if (gift2Url) img.src = gift2Url;
      });
    }

    resolveGiftUrl(url) {
      if (!url || typeof url !== 'string') return '';

      const trimmed = url.trim();
      if (!trimmed) return '';

      const cdnMatch = trimmed.match(/\/cdn\/shop\/[^\s"']+/);
      if (cdnMatch) return cdnMatch[0];

      if (trimmed.startsWith('//')) {
        return `${window.location.protocol}${trimmed}`;
      }

      return trimmed;
    }

    getGalleryContainer() {
      // Buy box lives inside the "product info" column; the gallery is a sibling in the same layout.
      const layout = this.root.closest('.shop-product-layout');
      return layout?.querySelector('.product-gallery') || document.querySelector('.product-gallery');
    }

    getGalleryMediaMap() {
      const gallery = this.getGalleryContainer();
      if (!gallery) return null;
      const mapEl =
        gallery.querySelector('.product-variant-media-map') ||
        gallery.closest('.shop-carousel-container')?.querySelector('.product-variant-media-map');
      if (!mapEl) return null;
      try {
        return JSON.parse(mapEl.textContent);
      } catch (e) {
        return null;
      }
    }

    getOptionAltMatchers(optionKey) {
      const key = String(optionKey || this.selectedOption || '').toLowerCase();
      if (key === 'starter') return ['kit'];
      if (key === 'partner') return ['pack'];
      if (key === 'onetime') return ['purchase', 'one-time', 'one time'];
      return [];
    }

    getMappedOptionMediaId(variantId, optionKey) {
      const entry = this.optionMediaMap?.[String(variantId)];
      if (!entry) return null;
      const mediaId = entry[optionKey];
      return mediaId ? String(mediaId) : null;
    }

    findMediaIdByAlt(matchers, allowedMediaIds, variantId) {
      const normalize = (s) => String(s || '').trim().toLowerCase();
      const needles = (Array.isArray(matchers) ? matchers : [matchers]).map(normalize).filter(Boolean);
      if (!needles.length || !this.galleryMediaAlts || !allowedMediaIds?.length) return null;

      const allowedSet = new Set(allowedMediaIds.map((id) => String(id)));
      const variant = this.variants.find((v) => String(v.id) === String(variantId));
      const variantKeywords = variant
        ? [variant.option1, variant.option2, variant.option3, variant.title]
            .map(normalize)
            .filter(Boolean)
        : [];

      let bestId = null;
      let bestScore = -1;

      for (const [mediaId, alt] of Object.entries(this.galleryMediaAlts)) {
        if (!allowedSet.has(String(mediaId))) continue;

        const altNorm = normalize(alt);
        if (!altNorm || !needles.some((needle) => altNorm.includes(needle))) continue;

        let score = 1;
        if (variantKeywords.some((keyword) => altNorm.includes(keyword))) score += 10;

        if (score > bestScore) {
          bestScore = score;
          bestId = String(mediaId);
        }
      }

      return bestId;
    }

    ensureGalleryReady() {
      if (typeof window.ProductGallery?.initAll === 'function') {
        window.ProductGallery.initAll();
      }
    }

    syncGallery() {
      const variantId = this.getGalleryVariantId();
      if (!variantId) return;

      const optionKey = this.selectedOption;
      let mediaId = this.getMappedOptionMediaId(variantId, optionKey);

      if (!mediaId) {
        const matchers = this.getOptionAltMatchers(optionKey);
        const mediaMap = this.getGalleryMediaMap();
        let allowedMediaIds = null;

        if (mediaMap && window.VariantMediaGroups?.getMediaIdsForVariant) {
          allowedMediaIds = window.VariantMediaGroups.getMediaIdsForVariant(variantId, mediaMap);
        }

        mediaId = this.findMediaIdByAlt(matchers, allowedMediaIds, variantId);
      }

      if (!mediaId) {
        const variant = this.variants.find((v) => String(v.id) === String(variantId));
        mediaId =
          this.variantMediaIds[String(variantId)] ||
          variant?.featured_media?.id ||
          null;
        if (mediaId) mediaId = String(mediaId);
      }

      const detail = { variantId: Number(variantId) || variantId };
      if (mediaId) detail.mediaId = Number(mediaId) || mediaId;

      const dispatch = () => {
        this.ensureGalleryReady();
        document.dispatchEvent(new CustomEvent('variant:imageChanged', { detail }));
      };

      requestAnimationFrame(() => {
        requestAnimationFrame(dispatch);
      });
    }

    getGalleryVariantId() {
      const vvbChecked = document.querySelector('.vvb-variant-input:checked');
      if (vvbChecked?.value && this.selectedOption !== 'partner') {
        return vvbChecked.value;
      }

      if (this.selectedOption === 'partner' && this.variantSelects.length > 0) {
        return this.variantSelects[0].value || this.defaultVariantId;
      }

      return this.defaultVariantId;
    }

    syncVariantVisuals(variantId) {
      this.applyAccentColors(variantId);
      this.updateGiftImages(variantId);
      this.syncGallery();
    }

    bindVariantAccentListeners() {
      if (this.mainVariantInput) {
        this.mainVariantInput.addEventListener('change', () => {
          if (this.mainVariantInput.value) {
            this.defaultVariantId = this.mainVariantInput.value;
            this.syncPartnerSelectsFromMain(this.defaultVariantId);
            this.updateFormInputs();
            this.syncVariantVisuals(this.getAccentVariantId());
          }
        });
      }

      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
          const variant = event?.data?.variant;
          if (!variant?.id) return;
          if (this.sectionId && event.data.sectionId && event.data.sectionId !== this.sectionId) return;

          this.defaultVariantId = String(variant.id);
          if (this.mainVariantInput) {
            this.mainVariantInput.value = this.defaultVariantId;
          }
          this.syncPartnerSelectsFromMain(this.defaultVariantId);
          this.updateFormInputs();
          this.syncVariantVisuals(this.getAccentVariantId());
        });
      }

      document.addEventListener('change', (event) => {
        const vvbInput = event.target.closest?.('.vvb-variant-input');
        if (!vvbInput?.value) return;
        this.defaultVariantId = vvbInput.value;
        if (this.mainVariantInput) {
          this.mainVariantInput.value = this.defaultVariantId;
        }
        this.syncPartnerSelectsFromMain(this.defaultVariantId);
        this.updateFormInputs();
        this.syncVariantVisuals(this.getAccentVariantId());
      });
    }

    init() {
      this.options.forEach((option) => {
        option.addEventListener('click', (event) => {
          if (event.target.closest('.sbb-variant-select, .sbb-qty-btn, .sbb-qty-input')) return;
          this.selectOption(option.dataset.option);
        });

        const input = option.querySelector('.sbb-option-input');
        if (input) {
          input.addEventListener('change', () => {
            if (input.checked) this.selectOption(option.dataset.option);
          });
        }
      });

      this.variantSelects.forEach((select) => {
        select.addEventListener('change', () => {
          this.updateVariantThumb(select);
          this.updateFormInputs();
          this.applyAccentColors(this.getAccentVariantId());
          this.updateGiftImages(this.getAccentVariantId());
          this.syncGallery();
        });
        this.updateVariantThumb(select);
      });

      this.bindVariantAccentListeners();
      this.bindQuantityControls();

      if (this.form) {
        this.form.addEventListener(
          'submit',
          () => {
            this.updateFormInputs();
          },
          true
        );
      }

      this.selectOption(this.selectedOption, false);
    }

    selectOption(optionKey, animate = true) {
      this.selectedOption = optionKey;

      this.options.forEach((option) => {
        const isSelected = option.dataset.option === optionKey;
        option.classList.toggle('is-selected', isSelected);
        const input = option.querySelector('.sbb-option-input');
        if (input) input.checked = isSelected;
      });

      this.syncAccordion(optionKey, animate);

      if (optionKey === 'partner') {
        this.syncPartnerSelectsFromMain(this.defaultVariantId);
      }

      this.updateFormInputs();
      this.syncVariantVisuals(this.getAccentVariantId());
    }

    updateVariantThumb(select) {
      const boxIndex = select.dataset.boxSelect;
      const selectedOption = select.options[select.selectedIndex];
      const imageUrl = selectedOption?.dataset.image;
      const thumb = this.root.querySelector(`[data-box-thumb="${boxIndex}"]`);
      if (thumb && imageUrl) thumb.src = imageUrl;
    }

    getPartnerVariantIds() {
      return Array.from(this.variantSelects).map((select) => select.value);
    }

    clearDynamicInputs() {
      if (this.dynamicInputs) this.dynamicInputs.innerHTML = '';
    }

    appendItemInput(index, variantId, quantity, sellingPlanId) {
      const idInput = document.createElement('input');
      idInput.type = 'hidden';
      idInput.name = `items[${index}][id]`;
      idInput.value = variantId;
      idInput.classList.add('sbb-dynamic-item-id');

      const qtyInput = document.createElement('input');
      qtyInput.type = 'hidden';
      qtyInput.name = `items[${index}][quantity]`;
      qtyInput.value = quantity;
      qtyInput.classList.add('sbb-dynamic-item-qty');

      this.dynamicInputs.appendChild(idInput);
      this.dynamicInputs.appendChild(qtyInput);

      if (sellingPlanId) {
        const planInput = document.createElement('input');
        planInput.type = 'hidden';
        planInput.name = `items[${index}][selling_plan]`;
        planInput.value = sellingPlanId;
        planInput.classList.add('sbb-dynamic-item-plan');
        this.dynamicInputs.appendChild(planInput);
      }
    }

    appendSellingPlanInput(planId) {
      const planInput = document.createElement('input');
      planInput.type = 'hidden';
      planInput.name = 'selling_plan';
      planInput.value = planId;
      planInput.classList.add('sbb-dynamic-selling-plan');
      this.dynamicInputs.appendChild(planInput);
    }

    isMainVariantAvailable(variantId) {
      const variant = this.variants.find((v) => String(v.id) === String(variantId));
      return variant ? variant.available : false;
    }

    isGiftAvailable(giftKey) {
      if (giftKey === 'gift1') {
        return this.gift1Id ? this.gift1Available : true;
      }
      if (giftKey === 'gift2') {
        return this.gift2Id ? this.gift2Available : true;
      }
      return true;
    }

    updateSubmitButton(canSubmit, variantAvailable) {
      if (!this.submitBtn) return;

      this.submitBtn.disabled = !canSubmit;
      this.submitBtn.classList.toggle('sold-out', !variantAvailable);

      const buttonText = this.submitBtn.querySelector('.button-text');
      if (buttonText) {
        buttonText.textContent = variantAvailable ? this.defaultButtonText : this.soldOutText;
      }
    }

    updateFormInputs() {
      this.clearDynamicInputs();

      let canSubmit = true;
      let variantAvailable = true;
      let itemIndex = 0;

      if (this.selectedOption === 'starter') {
        this.mainVariantInput.removeAttribute('name');

        this.appendItemInput(itemIndex++, this.defaultVariantId, 1, this.starterPlanId || null);
        if (!this.isMainVariantAvailable(this.defaultVariantId)) {
          canSubmit = false;
          variantAvailable = false;
        }

        if (this.gift1Id && this.isGiftAvailable('gift1')) {
          this.appendItemInput(itemIndex++, this.gift1Id, 1, null);
        }
        if (this.gift2Id && this.isGiftAvailable('gift2')) {
          this.appendItemInput(itemIndex++, this.gift2Id, 1, null);
        }
      } else if (this.selectedOption === 'partner') {
        this.mainVariantInput.removeAttribute('name');

        const partnerVariants = this.getPartnerVariantIds();
        partnerVariants.forEach((variantId) => {
          this.appendItemInput(itemIndex++, variantId, 1, this.partnerPlanId || null);
          if (!this.isMainVariantAvailable(variantId)) {
            canSubmit = false;
            variantAvailable = false;
          }
        });

        if (this.gift1Id && this.isGiftAvailable('gift1')) {
          this.appendItemInput(itemIndex++, this.gift1Id, 1, null);
        }
        if (this.gift2Id && this.isGiftAvailable('gift2')) {
          this.appendItemInput(itemIndex++, this.gift2Id, 1, null);
        }
      } else {
        this.mainVariantInput.name = 'id';
        this.mainVariantInput.value = this.defaultVariantId;

        const quantity = this.getOnetimeQuantity();
        const qtyInput = document.createElement('input');
        qtyInput.type = 'hidden';
        qtyInput.name = 'quantity';
        qtyInput.value = quantity;
        qtyInput.classList.add('sbb-dynamic-quantity');
        this.dynamicInputs.appendChild(qtyInput);

        if (!this.isMainVariantAvailable(this.defaultVariantId)) {
          canSubmit = false;
          variantAvailable = false;
        }
      }

      this.updateSubmitButton(canSubmit, variantAvailable);
    }
  }

  function initSubscriptionBuyBoxes() {
    document.querySelectorAll('.subscription-buy-box').forEach((root) => {
      if (root.dataset.sbbInitialized) return;
      root.dataset.sbbInitialized = 'true';
      new SubscriptionBuyBox(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSubscriptionBuyBoxes);
  } else {
    initSubscriptionBuyBoxes();
  }

  document.addEventListener('shopify:section:load', initSubscriptionBuyBoxes);
})();
